const data = {
    bronnen: [
      {
        id: "1",
        auteur: "Commissie voor de milieueffectrapportage",
        titel: "Module Energie Omgevingsbeleid Provincie Zuid-Holland: Advies over reikwijdte en detailniveau van het milieueffectrapport",
        jaar: "2022",
        link: "https://www.commissiemer.nl/docs/mer/p35/p3592/a3592rd.pdf"
      },
      {
        id: "2",
        auteur: "Gebieden die geen ruimtelijke afweging behoeven, zoals zon op dak, zon op geluidsschermen, zon op waterbassins en zon op parkeerplaatsen, zijn in de scope van dit MER, daar waar evident, niet op de kaart geplaatst",
      },
      {
        id: "3",
        auteur: "Provincie Zuid-Holland",
        titel: "Ontwerp Herziening module Energietransitie",
        jaar: "2022",
        link: "https://pzh.notubiz.nl/document/11437107/1"
      },
      {
        id: "4",
        auteur: "Provincie Zuid-Holland",
        titel: "Ontwerp Herziening Omgevingsbeleid module energietransitie 2022, 3-1-3 Bevorderen energietransitie",
        jaar: "2022",
        link: "https://pzh.notubiz.nl/document/11437107/1",
        pagina: "p. 67."
      },
      {
        id: "5",
        auteur: "Commissie voor de milieueffectrapportage",
        titel: "Module Energie Omgevingsbeleid Provincie Zuid-Holland: Advies over reikwijdte en detailniveau van het milieueffectrapport",
        jaar: "2022",
        link: "https://www.commissiemer.nl/docs/mer/p35/p3592/a3592rd.pdf",
      },
      {
        id: "6",
        auteur: "Provincie Zuid-Holland",
        titel: "Ontwerp Herziening Omgevingsbeleid module energietransitie 2022, 3-1-3 Bevorderen energietransitie",
        jaar: "2022",
        link: "https://pzh.notubiz.nl/document/11437107/1",
        pagina: "p. 58."
      },
      {
        id: "7",
        auteur: "Zie de link voor het vastgestelde Statenvoorstel:",
        link: "https://pzh.notubiz.nl/document/11279096/1/7358+Statenvoorstel+Vaststellen+regionale+energiestrategie%C3%ABn1_0",
      },
      {
        id: "8",
        auteur: "Provincie Zuid-Holland",
        titel: "Leefomgevingstoets herziening module Energietransitie",
        jaar: "2022",
        link: "https://pzh.notubiz.nl/document/11437101/1"        
      },
      {
        id: "9",
        auteur: "Gebieden die geen ruimtelijke afweging behoeven, zoals zon op dak, zon op geluidsschermen, zon op waterbassins en zon op parkeerplaatsen, zijn in de scope van dit MER, daar waar evident, niet op de kaart geplaatst.",
      },
      {
        id: "10",
        auteur: "Provincie Zuid-Holland",
        titel: "Monitor Leefomgeving",
        link: "https://monitorleefomgeving.zuid-holland.nl/",
      },
      {
        id: "11",
        auteur: "Een werkgroep met juristen en beleidsexperts van Rijk, provincies, gemeenten, NP RES, netbeheerders en de commissie m.e.r. heeft op 14 april 2022 een advies uitgebracht over in hoeverre er op basis van nationale en/of Europese regelgeving een plicht bestaat om een milieueffectrapportrapportage (mer) uit te voeren bij de Regionale Energiestrategie. Kern van het advies is dat voor het tot stand komen van de RES 1.0 een plan-mer niet verplicht was. De RES 2.0 is na het in werking treden van de Omgevingswet soms plan-mer plichtig. Dit heeft gevolgen voor de inrichting van het RES-proces. Er zal voortaan een onderscheid worden gemaakt tussen een RES Voortgangsdocument en een RES Herijking. Achtergrondinformatie:",
        link: "https://www.regionale-energiestrategie.nl/Nieuws/2200342.aspx?t=Milieueffectrapportage-soms-verplicht-voor-Regionale-Energiestrategie",
      },
      {
        id: "12",
        auteur: "Provincie Zuid-Holland",
        titel: "Monitor Leefomgeving",
        link: "https://monitorleefomgeving.zuid-holland.nl/",
      },
      {
        id: "13",
        auteur: "  Zie toelichting in paragraaf 1.5 en via:",
        link: "https://www.regionale-energiestrategie.nl/Nieuws/2200342.aspx?t=Milieueffectrapportage-soms-verplicht-voor-Regionale-Energiestrategie",
      },
      {
        id: "14",
        auteur: "Commissie voor de milieueffectrapportage",
        titel: "Uitgebreide m.e.r.-procedure",
        link: "https://www.commissiemer.nl/documenten/00000216.pdf",
      },
      {
        id: "15",
        auteur: "Commissie voor de milieueffectrapportage",
        titel: "Module Energie Omgevingsbeleid Provincie Zuid-Holland: Advies over reikwijdte en detailniveau van het milieueffectrapport",
        jaar: "2022",
        link: "https://www.commissiemer.nl/docs/mer/p35/p3592/a3592rd.pdf",
      },
      {
        id: "16",
        auteur: "Voor de vaststellingsbrief NRD van de Gedeputeerde Staten Zuid-Holland zie:",
        link: "https://pzh.notubiz.nl/document/11242268/1",
      },
      {
        id: "17",
        auteur: "Voor de Nota van Beantwoording Ontwerp Notitie Reikwijdte en Detailniveau Module Energietransitie. Zie:",
        link: "https://pzh.notubiz.nl/document/11242272/1",
      },
      {
        id: "18",
        auteur: "Ministerie van Economische Zaken en Klimaat",
        titel: "Klimaatakkoord",
        jaar: "2019",
        // link: "",
        pagina: "p. 4."
      },
      {
        id: "19",
        auteur: "Energieakkoord, Rijksdienst voor Ondernemend Nederland",
        link: "https://www.rvo.nl/onderwerpen/duurzaam-ondernemen/energieakkoord",
      },
      {
        id: "20",
        auteur: "Ministerie van Binnenlandse Zaken en Koninkrijkrelaties",
        titel: "NOVI",
        link: "https://denationaleomgevingsvisie.nl/over+de+novi/nationale+omgevingsvisie+in+het+kort/default.aspx. ",
        
      },
      {
        id: "21",
        auteur: "Rijksoverheid",
        titel: "Wetgeving voor natuurbescherming in Nederland",
        link: "https://www.rijksoverheid.nl/onderwerpen/natuur-en-biodiversiteit/wetgeving-voor-natuurbescherming-in-nederland",
      },
      {
        id: "22",
        auteur: "Rijksoverheid",
        titel: "Structuurvisie Ondergrond",
        link: "https://www.rijksoverheid.nl/documenten/rapporten/2018/06/11/structuurvisie-ondergrond",
      },
      {
        id: "23",
        auteur: "Rijkswaterstaat",
        titel: "Wet milieubeheer",
        link: "https://www.rijkswaterstaat.nl/water/wetten-regels-en-vergunningen/natuur-en-milieuwetten/wet-milieubeheer",
      },
      {
        id: "24",
        auteur: "Voor een nadere toelichting zie:",
        link: "https://www.infomil.nl/onderwerpen/integrale/uitspraak-raad-state/gevolgen-raad-state-uitspraak-windturbineparken/actieprogramma/",
      },
      {
        id: "25",
        auteur: "Royal HaskoningDHV",
        titel: "Eindrapportage Verkenning robuuste drinkwatervoorziening 2040",
        jaar: "2021",
        link: "https://www.rijksoverheid.nl/documenten/rapporten/2021/09/30/eindrapportage-verkenning-robuuste-drinkwatervoorziening-2040",
        pagina: "p. 4."
      },
      {
        id: "26",
        auteur: "Voor de kwaliteitskaart, zie:",
        link: "https://gebiedsprofielen.zuid-holland.nl/Gebiedsprofielen/website/index.html?webmap=7f51b45574524e0c92d831237d7eb5ef",
      },
      {
        id: "27",
        auteur: "Gebaseerd op de beschrijving van de RES op de Staat van Zuid-Holland:",
        link: "https://staatvan.zuid-holland.nl/portfolio_page/res-strategieen/",
      },
      {
        id: "28",
        auteur: "Zie Monitor Leefomgeving Provincie Zuid-Holland: ",        
        link: "https://monitorleefomgeving.zuid-holland.nl/Natuur#Kwaliteitgebieden",
      },
      {
        id: "29",
        auteur: "Effectafstanden en bronverwijzingen afkomstig uit planMER grootschalige zon en wind RES Metropoolregio Eindhoven",
        jaar: "2020",
      },
      {
        id: "30",
        auteur: "Sweco",
        titel: "Stikstofopgaven provincie Zuid-Holland: Inzicht in de stikstofdepositie voor strategische opgaven van de provincie Zuid-Holland",
        jaar: "2021",        
        pagina: "p. 18-26."
      },
      {
        id: "31",
        auteur: "Sweco",
        titel: "Stikstofopgaven provincie Zuid-Holland: Inzicht in de stikstofdepositie voor strategische opgaven van de provincie Zuid-Holland",
        jaar: "2021",
        pagina: "p. 18-26."
      },
      {     
        id: "32",
        auteur: "Zie: Monitor Leefomgeving Provincie Zuid-Holland",
        link: "https://monitorleefomgeving.zuid-holland.nl/Natuur",
      },
      {
        id: "33",
        auteur: "Provincie Zuid-Holland",
        titel: "Natuurnetwerk Nederland (NNN)",
        link: "https://www.zuid-holland.nl/onderwerpen/natuur-landschap/natuurrijk-zuid/ontwikkeling/",
      },
      {
        id: "34",
        auteur: "De Beleidsregel Compensatie Natuur, Recreatie en Landschap Zuid-Holland 2013 bevat regels en uitleg ten aanzien van de bescherming en de compensatie voor aantasting van belangrijke weidevogelgebieden. Toegankelijk via:",
        link: "https://www.zuid-holland.nl/publish/pages/24682/2013-138_beleidsregel_compensatie_natuur_recreatie_en_landschap_zuid-holland_20131.pdf",
      },
      {
        id: "35",
        auteur: "Faunabeheereenheid Zuid-Holland",
        titel: "Faunabeheerplan Ganzen Zuid-Holland 2022 - 2027",
        jaar: "2021",
        link: "https://www.fbezh.nl/ganzen-fbp/",        
      },
      {
        id: "36",
        auteur: "Wageningen University & Research",
        titel: "Kwetsbare soorten voor energie-infrastructuur in Nederland",
        jaar: "2018",
        link: "https://edepot.wur.nl/449804"        
      },
      {
        id: "37",
        auteur: "Voor een overzicht van studies naar de gevoeligheid van vleermuizen voor windturbines, zie: Gevoeligheid van vogels en vleermuizen voor windturbines in de provincie Utrecht. Via:",
        link: "https://geo.provincie-utrecht.nl/publiek/documenten/milieu/energietransitie/Rap_2021-18_Utrecht%20gevoeligheid%20vogels%20en%20vleermuizen%20windturbines_def.pdf",
      },
      {
        id: "38",
        auteur: "Sovon",
        titel: "Achtergronddocument windenergie gevoeligheidskaart vogels",
        jaar: "2021",
        link: "https://www.sovon.nl/sites/default/files/doc/rap_2021-09_windenergie-gevoeligheidskaart.pdf",
      },
      {
        id: "39",
        auteur: "In paragraaf 4.3 is de impact van het realiseren van zonne-energie en windenergie in weidevogelgebieden beoordeeld",
      },
      {
        id: "40",
        auteur: "Wageningen University & Research",
        titel: "Kwetsbare soorten voor energie-infrastructuur in Nederland",
        jaar: "2018",
        link: "https://edepot.wur.nl/449804",        
      },
      {
        id: "41",
        auteur: "Zie: Monitor Leefomgeving Provincie Zuid-Holland",
        link: "https://monitorleefomgeving.zuid-holland.nl/Milieuengezondheid#Geluid%E2%80%93berekendgeluidlangsprovincialewegen",
      },
      {
        id: "42",
        auteur: "Verschillende milieueffectenrapporten geven een uitgebreide verhandeling van de verschillende onderzoeken naar geluid van windturbines en de effecten van dit geluid. Zie bijvoorbeeld Bosch & Van Rijn",
        titel: "PlanMER grootschalige zon en wind Regionale Energiestrategie (RES) Metropoolregio Eindhoven",
        jaar: "2020",
        link: "https://www.commissiemer.nl/projectdocumenten/00008605.pdf",
      },
      {
        id: "43",
        auteur: "Sinds een uitspraak van de Raad van State (RvS) op 30 juni 2021 kunnen de rijksregels voor windturbineparken in het Activiteitenbesluit niet meer worden toegepast. Om opnieuw rijksregels voor windturbineparken vast te stellen, moet het Rijk eerst een milieueffectrapport (MER) maken. Voor een nadere toelichting zie:",
        link: "https://www.infomil.nl/onderwerpen/integrale/uitspraak-raad-state/gevolgen-raad-state-uitspraak-windturbineparken/actieprogramma/",      
      },
      {
        id: "44",
        auteur: "Onder geluidsgevoelige objecten worden verstaan: woningen, onderwijsgebouwen, ziekenhuizen, verpleeghuizen, verzorgingstehuizen, psychiatrische inrichtingen, kinderdagverblijven, woonwagenstandplaatsen en ligplaatsen voor woonschepen. Bron: Wet geluidhinder",
      },
      {
        id: "45",
        auteur: "Generation.Energy & CE Delft",
        titel: "Analysekaarten NP RES: Verantwoording bronnen en methoden",
        jaar: "versie 3.0 – December 2020",
        link: "https://www.regionale-energiestrategie.nl/documenten/handlerdownloadfiles.ashx?idnv=1310850",        
      },
      {
        id: "46",
        auteur: "Zie:",
        // titel: "",
        // jaar: "",
        link: "https://monitorleefomgeving.zuid-holland.nl/Verstedelijkingenmobiliteit#Woningvoorraadontwikkeling",
        // pagina: ""
      },
      {
        id: "47",
        auteur: "Omgevingsverordening Zuid-Holland, Artikel 6.10 Stedelijke ontwikkelingen, 1b: Indien in de behoefte aan de stedelijke ontwikkeling niet binnen bestaand stads- en dorpsgebied kan worden voorzien en voor zover daarvoor een locatie groter dan 3 hectare nodig is, wordt gebruik gemaakt van grote buitenstedelijke bouwlocaties waarvan de plaats geometrisch is bepaald en verbeeld op kaart 19 in bijlage II en wordt rekening gehouden met de voor deze locaties opgenomen gegevens en criteria",
      },
      {
        id: "48",
        auteur: "Generation.Energy & CE Delft",
        titel: "Analysekaarten NP RES: Verantwoording bronnen en methoden",
        jaar: "versie 3.0 - December 2020",
        link: "https://www.regionale-energiestrategie.nl/documenten/handlerdownloadfiles.ashx?idnv=1310850",
        pagina: "p. 69-77"
      },
      {
        id: "49",
        auteur: "Bijvoorbeeld: LPG-stations, BRZO-bedrijven en overige bedrijven met opslag van gevaarlijke stoffen",
      },
      {
        id: "50",
        auteur: "Voor bovengronds transport van gevaarlijke stoffen gelden grotere adviesafstanden. Alle transportleidingen in deze berekening zijn berekend als ondergrondse leidingen. Kwalitatief is in de analyse aangegeven welke buisleidingen bovengronds lopen en daarmee een aanvullend risico vormen",
      },
      {
        id: "51",
        auteur: "Generation.Energy & CE Delft",
        titel: "Analysekaarten NP RES: Verantwoording bronnen en methoden",
        jaar: "versie 3.0 – December 2020",
        link: "https://www.regionale-energiestrategie.nl/documenten/handlerdownloadfiles.ashx?idnv=1310850",
      },
      {
        id: "52",
        auteur: " Op sommige plekken kan eerder opwekcapaciteit gerealiseerd worden dan op andere plekken. Uit de investeringsplannen van de netbeheerder en de E-kansenkaart samen kan dit overzicht worden gehaald (zoals ook openomen in de tabel. Binnenkort publiceert Liander een kaart waarop dit in één keer te zien is",
      },
      {
        id: "53",
        auteur: "Achtergrond: Om te zorgen dat de energie-infrastructuur in de toekomst betaalbaar, betrouwbaar en toegankelijk blijft voor iedereen en op de gewenste locaties, is het belangrijk om de impact van regionale keuzes op de energie-infrastructuur inzichtelijk te maken. De netbeheerders hebben hiervoor in samenspraak met PBL en NP RES een werkwijze ontwikkeld om de netimpact van de regionale plannen uit te werken. Het ‘Netimpact bepalen werkproces' is onderdeel van het afwegingskader Energiesysteem Efficiëntie uit de Handreiking Regionale Energiestrategie 1.1",
      },
      {
        id: "54",
        auteur: "Deze analyse is gebaseerd op de stations binnen de Provincie Zuid-Holland. Mogelijk kunnen projecten in zoekgebieden aan de randen van de provinciegrens aangesloten worden op het netwerk in Noord-Holland en Utrecht",
      },
      {
        id: "55",
        auteur: "Webviewer Provincie Zuid-Holland, bijgewerkt op 22 juni 2022:",
        link: "https://www.zuid-holland.nl/onderwerpen/energie/windenergie/",
      },
      {
        id: "56",
        auteur: "GS-brief Beleidsevaluaties en subsidies, 6 mei 2021",
      },
      {
        id: "57",
        auteur: "Provincie Zuid-Holland ",
        titel: "Lange Termijnagenda",
        link: "https://lta.zuid-holland.nl/5/",
      },
      {
        id: "58",
        auteur: "Provincie Zuid-Holland",
        titel: "Monitor Leefomgeving",
        link: "https://monitorleefomgeving.zuid-holland.nl/",
      },     
    ]
};

export default data